<template>
  <div>
    <div v-show="showClickableDiv" class="clickable-div pointer" @click="expand">
      <slot name="clickable-content" />
    </div>
    <div v-show="expanded" class="expandable-div">
      <slot name="expandable-content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    keepClickableContentDisplayed: { type: Boolean, default: false },
    expandByDefault: { type: Boolean, default: false },
  },
  data() {
    return {
      showExpandableContent: false,
    }
  },
  computed: {
    showClickableDiv() {
      return this.keepClickableContentDisplayed || !this.expanded
    },
    expanded() {
      return this.expandByDefault || this.showExpandableContent
    },
  },
  methods: {
    expand() {
      this.$emit('expand')
      this.showExpandableContent = true
    },
  },
}
</script>

<style scoped>
.clickable-div:hover {
  cursor: pointer;
}
</style>
